import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { ACTIVITY_STATUS } from '../../utils/constants';

export default function ActivityStatusSelector({
  input,
  t,
  editable,
  updateStatus,
  ...rest
}) {
  return (
    <MuiThemeProvider>
      <RadioButtonGroup
        {...input}
        {...rest}
        valueSelected={input.value}
        onChange={(event, value) => {
          updateStatus(value);
        }}
        style={{ display: 'flex', width: '100%' }}
      >
        <RadioButton
          iconStyle={{ fill: '#30313f' }}
          labelStyle={{ color: '#30313f' }}
          value={ACTIVITY_STATUS.CONCLUED}
          label={t(`communication.activityDetails.conclued`)}
          disabled={editable}
        />
        <RadioButton
          iconStyle={{ fill: '#30313f' }}
          labelStyle={{ color: '#30313f' }}
          value={ACTIVITY_STATUS.NOT_CONCLUED}
          label={t(`communication.activityDetails.notConclued`)}
          disabled={editable}
        />
        <RadioButton
          iconStyle={{ fill: '##30313f' }}
          labelStyle={{ color: '##30313f' }}
          value={ACTIVITY_STATUS.REVISION}
          label={t(`communication.activityDetails.revision`)}
          disabled={editable}
        />
      </RadioButtonGroup>
    </MuiThemeProvider>
  );
}

ActivityStatusSelector.propTypes = {
  input: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  updateStatus: PropTypes.func.isRequired,
};
